import { createActions } from 'redux-actions';
var prefix = 'APP';
var actionTypes = ['SET_QUOTES'];
export default createActions.apply(void 0, actionTypes.concat([{
  prefix: prefix
}]));